import type { ClaimStatusI } from 'declarations/interfaces/claimStatuses';

import { get } from './api';

export const getClaimStatusesApi = async (
  roofTopId: string | undefined
): Promise<ClaimStatusI[]> => {
  const response = await get<ClaimStatusI[]>('/tickets/claim-statuses', { roofTopId });
  return response.data;
};
